require('./bootstrap');

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

// init sentry only on production
if (process.env.MIX_APP_ENV === 'production') {
    Sentry.init({
        dsn: "https://99365acabadc452aaba6ae73c02eb65f@o1181251.ingest.sentry.io/6294559",
        integrations: [new BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0,
    });
}
